import { getData } from "../../services/library";
import { UrlApi } from "../../services/apirest";
import { getUserBranchesFilter } from "../ventas/facturacion/helpers";
import { dePedidoARemito, deEnvasadoPedidoARemito } from "./helpers";

export const getPedidos = (setPedidos) => {
  const sucursales = getUserBranchesFilter();
  getData(`/remitos/pedidos-remitos-suc/${sucursales}`, setPedidos);
};

export const obtenerPrecioEspecial = (
  idCliente,
  unidadFact,
  setPrecioUnitario
) => {
  fetch(UrlApi + "/precios_especiales/xcliente/" + idCliente)
    .then((data) => data.json())
    .then((data) => {
      if (unidadFact === 215) {
        setPrecioUnitario(data[0].kg_sin_iva);
      } else {
        setPrecioUnitario(data[0].lt_sin_iva);
      }
    });
};

export const obtenerPrecioLista = (
  dataCliente,
  pedidosAFacturar,
  unidadFact,
  setPrecioUnitario
) => {
  const url = `${UrlApi}/lista_precios/fechavigente/${dataCliente.id_empresa}/${dataCliente.id_sucursal}/${dataCliente.id_segmento}/${pedidosAFacturar[0].id_producto}`;
  fetch(url)
    .then((data) => data.json())
    .then((data) => {
      if (unidadFact === 215) {
        setPrecioUnitario(data[0].precio_kilo_sin_iva);
      } else {
        setPrecioUnitario(data[0].precio_litro_sin_iva);
      }
    });
};

export async function getSetSuc(userData, setSucursales, setSucEmiteFactura) {
  const allSucs = await fetch(`${UrlApi}/sucursales`)
    .then((data) => data.json())
    .then((data) => {
      return data;
    });
  if (!userData.esControlador) {
    const sucsShow = allSucs.filter((suc) => suc.id == userData.sucursal);
    setSucursales(sucsShow);
    setSucEmiteFactura(sucsShow[0]);
  } else {
    const sucsAuth = userData.sucursalAuth.split(",");
    const sucsShow = allSucs.filter((suc) => sucsAuth.includes(String(suc.id)));
    setSucursales(sucsShow);
    setSucEmiteFactura(null);
  }
}

export async function getPedidORemit(
  keyMapRutas,
  value,
  setLoadingRemitos,
  setRemitosCliente
) {
  setLoadingRemitos(true);
  const { id_tipocliente, id_empresa } = value;
  const rutas = keyMapRutas[id_tipocliente];
  let allRemitosPedidos = [];

  try{
    for (const ruta of rutas) {
        const rutaCompleta = UrlApi + ruta + value.id;
        const res = await fetch(rutaCompleta);
        const data = await res.json();
        allRemitosPedidos = [...allRemitosPedidos, ...data];
      }
    
      const regsRemitos = allRemitosPedidos.filter((remitos) => remitos.id_remito);

      const pedidosToRemitos = dePedidoARemito(allRemitosPedidos, id_empresa, id_tipocliente)
      
      const allRemitos = [...regsRemitos, ...pedidosToRemitos]
      setRemitosCliente(allRemitos)
  } catch(error){
    console.error("Error al traer pedidos:", error);
    alert(error)
  } finally {
      setLoadingRemitos(false)
  }
}

export async function getLetra(sitIva, setLetra) {
  getData(`/facturacion_tipos_comprobantes/iva/${Number(sitIva)}`, setLetra);
}

// Trae los remitos a facturar de envasado (por cliente facturar_a): los remitos
// reales de la tabla remitos (id_tipo_cliente 3) + los pedidos de envasado
// convertidos a la forma de "remito con items" que consume NuevaFacturacion.
export async function getRemitosEnvasado(
  facturarA,
  idEmpresa,
  setLoadingRemitos,
  setRemitosCliente
) {
  setLoadingRemitos(true);
  try {
    const [renglonesRes, remitosRes] = await Promise.all([
      fetch(`${UrlApi}/envasado_pedidos_renglon/renglonesremitos/${facturarA}`),
      fetch(`${UrlApi}/remitos/a-facturar/envasado/${facturarA}`),
    ]);
    const renglones = await renglonesRes.json();
    const regsRemitos = await remitosRes.json();
    const pedidosToRemitos = deEnvasadoPedidoARemito(renglones, idEmpresa);
    setRemitosCliente([
      ...(Array.isArray(regsRemitos) ? regsRemitos : []),
      ...pedidosToRemitos,
    ]);
  } catch (error) {
    console.error("Error al traer remitos de envasado:", error);
    alert(error);
  } finally {
    setLoadingRemitos(false);
  }
}
